export type EmrMirrorCommand =
  | {
    action: "OPEN";
    emrId: string;
    cartId?: string | null;
    ts: number;
  }
  | {
    action: "CLOSE";
    cartId?: string | null;
    ts: number;
  };


export type MembershipMirrorCommand =
  | { action: "OPEN"; userMembershipId: string; cartId?: string | null; ts: number }
  | { action: "CLOSE"; cartId?: string | null; ts: number };

export type PitchingMirrorCommand =
  | { action: "OPEN"; membershipId: string; cartId?: string | null; ts: number }
  | { action: "CLOSE"; cartId?: string | null; ts: number };

export type PaymentMirrorCommand = {
  action: "QR_SHOW" | "QR_INACTIVE" | "PAYMENT_SUCCESS";
  orderId: string;
  amount: number;
  qrBase64?: string;
  overdueAmount?: number;
  advanceAmount?: number;
  expiresIn?: number;
};

export const MEMBERSHIP_SIMULATION_EVENTS = {
  OPEN: "MEMBERSHIP_SIMULATION",
  SCROLL: "MEMBERSHIP_SIMULATION_SCROLL",
  CLOSE: "MEMBERSHIP_SIMULATION_CLOSE",
} as const;
